import React from "react";
import { Tooltip } from "antd";

const WorkerInfo = ({ user }) => (
  <Tooltip title={`${user.firstname} ${user.lastname}`}>
    {user.username}
  </Tooltip>
);

export default WorkerInfo;
